import React from 'react'
//import PropTypes from 'prop-types'
import './HeaderComponent.css'

import LogoComponent from '../LogoComponent'
import NavigationComponent from '../NavigationComponent'

import logoFull from '../../content/images/PrecentBlackFlat.svg'
import logoCircle from '../../content/images/PrecentCircle.svg'
import logoLetters from '../../content/images/PrecentLetters.svg'

const HeaderComponent = (props) => {
	return (
		<div className="HeaderComponent">
			<LogoComponent image={logoFull}/>
			<LogoComponent image={logoCircle}/>
			<LogoComponent image={logoLetters}/>
			<NavigationComponent />
		</div>
	)
}

HeaderComponent.propTypes = {
}

export default HeaderComponent


// WEBPACK FOOTER //
// ./src/components/HeaderComponent/HeaderComponent.js